export default __webpack_public_path__ + "static/media/Chemical Engineering.9950ae64.pdf";